import React from "react";
import VideoModal from "../../../shared/components/VideoModal";
import { useReactAppState } from "../../../shared/containers/utils";
import {
  modalActionTypes,
  modalTypes,
} from "../../../shared/hooks/useModalOptions";
import { TVIcon } from "../../../shared/svg/TVIcon/TVIcon";
import { highlightTypes, matchHighlightsTagSlug } from "../../../shared/utils";
import {
  StyledMatchWatchPost,
  StyledMatchWatchPostLabel,
} from "./StyledMatchWatch";
import Chevron from "./Chevron";

export const MatchWatchPost = ({ videoList = [], trackFn = () => null, showChevron, matchPageUrl }) => {
  const { t, updateModalOptions } = useReactAppState();
  const gameHighlights = videoList.find(
    (video) =>
      video?.fields?.highlightType === highlightTypes.gameHighlights ||
      video?.tags.find((tag) => tag?.slug === matchHighlightsTagSlug)
  );

  const openVideoModal = (currentVideo) => {
    const foundVideoIndex = videoList.findIndex((video) => {
      return currentVideo._entityId === video._entityId;
    });

    const videos = [
      currentVideo,
      ...videoList.slice(0, foundVideoIndex),
      ...videoList.slice(foundVideoIndex + 1),
    ];

    trackFn();

    updateModalOptions({
      type: modalActionTypes.modalClassName,
      payload: "mls-o-modal mls-o-modal--dark mls-o-modal--video-playlist",
    });
    updateModalOptions({
      type: modalActionTypes.modalType,
      payload: modalTypes.default,
    });
    updateModalOptions({
      type: modalActionTypes.label,
      payload: t("match_highlights"),
    });
    updateModalOptions({
      type: modalActionTypes.component,
      payload: VideoModal,
    });
    updateModalOptions({
      type: modalActionTypes.modalData,
      payload: { videoList: videos, video: currentVideo },
    });
    updateModalOptions({ type: modalActionTypes.show });
  };

  if (!gameHighlights) {
    if(showChevron) {
      return (
        <Chevron />
      );
    }

    return null;
  }

  return (
    <StyledMatchWatchPost onClick={() => openVideoModal(gameHighlights)}>
      <StyledMatchWatchPostLabel className="mls-c-match-list__match-watch-label">
        {t("highlights")}
      </StyledMatchWatchPostLabel>
      <TVIcon width={11} height={10} />
    </StyledMatchWatchPost>
  );
};
